export default {
    SET_REFERRAL_CODES: (state, referralCodes) => {
        state.referralCodes = referralCodes
    },

    EDIT_REFERRAL_CODE: (state, referralCode) => {
        const index = state.referralCodes.findIndex(code => code.id === referralCode.id)
        if (index !== -1) {
            state.referralCodes[index].name = referralCode.name
        }
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    }
}
